import styled from 'styled-components'

import { Icon as DefaultIcon } from '@/components/ui/icon'

export const ErrorMessage = styled.div(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.colors.visitorParkingErrorBg,
  border: `${theme.border.size['1']} solid ${theme.colors.visitorParkingErrorBorder}`,
  borderRadius: theme.border.radius['8'],
  color: theme.colors.visitorParkingErrorText,
  display: 'flex',
  fontSize: '1.4rem',
  fontWeight: 500,
  gap: theme.space['8'],
  padding: theme.space['12'],
  width: '100%',
}))

export const Icon = styled(DefaultIcon)(({ theme }) => ({
  color: theme.colors.visitorParkingErrorText,
  flexShrink: 0,
}))

export const MessageText = styled.span({
  flex: 1,
})
